<template>
  <div>
    <cheque-tabs></cheque-tabs>

    <m-form
        :title="title"
        :full-width="true"
        :items="items"
        :cols="cols"
        :canSubmit="canSubmit"
        :canDelete="canDelete"
        :is-editing.sync="isEditing"
        :showListBtn="false"
        apiUrl="reports/lists/chequebooks"
        :show-navigation-btns="false"
        @click:row="setItem"
        @clearForm="clearForm"
        @submit="submit"
        @delete="deleteItem"
    >
      <template #header-btns>
        <v-btn
            v-if="item.id"
            class="secondary white--text ml-2 mr-1 mt-1 mt-md-0 rounded-lg"
            depressed
            :to="{name: 'ChequesList', params: {type: 'c', isPaid: true}, query: {filters: JSON.stringify({chequebook__id: item.id})}}"
        >
          <v-icon class="ml-1"> fa-eye</v-icon>
          مشاهده چک ها
        </v-btn>
      </template>
      <template #default>
        <v-row>
          <v-col cols="3">
            <div  id="cheque-book-form-account">
              <account-select
                  :items-type="accountUsage.BANK"
                  label=" * حساب بانک"
                  v-model="item.account"
                  :disabled="!isEditing"
                  :deepSelect="false"
              />
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <div id="cheque-book-form-serial">
              <v-text-field class="rounded-lg" label="* سری" v-model="item.serial" :disabled="!isEditing"/>
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <div id="cheque-book-form-serial-from">
              <v-text-field
                  class="rounded-lg"
                  label=" * از شماره سریال"
                  type="number"
                  v-model="item.serial_from"
                  :disabled="!isEditing"
              />
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <div id="cheque-book-form-serial-to">
              <v-text-field
                  class="rounded-lg"
                  type="number"
                  label=" * تا شماره سریال"
                  v-model="item.serial_to"
                  :disabled="!isEditing"
              />
            </div>
          </v-col>
          <v-col cols="3">
            <div id="cheque-book-form-explanation">
              <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing">
              </v-textarea>
            </div>
          </v-col>
        </v-row>
      </template>
    </m-form>
  </div>
</template>

<script>
import {MFormMixin} from "@/components/m-form";

import accountApiMixin from "@/mixin/accountMixin";
import money from "@/components/mcomponents/cleave/Money";
import date from "@/components/mcomponents/cleave/Date";
import formsMixin from "@/mixin/forms";
import GetChequebookApi from "./getChequebooksApi";
import ChequeTabs from "@/views/panel/cheque/ChequeTabs";

export default {
  name: "ChequebookForm",
  components: {ChequeTabs, money, date},
  mixins: [MFormMixin, GetChequebookApi, accountApiMixin, formsMixin],
  data() {
    return {
      baseUrl: "cheques/chequebooks",
      permissionBasename: "chequebook",
      appendSlash: true,
      cols: [
        {
          text: "حساب",
          value: "account.name",
          type: "text",
          filters: ["account__name__icontains"],
        },
        {
          text: "سری",
          value: "serial",
          type: "text",
          filters: ["serial__icontains"],
        },
        {
          text: "از سریال",
          value: "serial_from",
          type: "number",
          filters: ["serial__icontains"],
        },
        {
          text: "تا سریال",
          value: "serial_to",
          type: "number",
          filters: ["serial__icontains"],
        },
        {
          text: "توضیحات",
          value: "explanation",
          type: "text",
          filters: ["account__icontains"],
        },
      ],
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('دسته چک')
    },
    items() {
      return this.chequebooks;
    },
  },
  methods: {
    getData() {
      this.getChequebooks(true);
    },
    getSerialized() {
      let item = this.extractIds(this.item);
      return item;
    },
  },
};
</script>

<style scoped lang="scss">
</style>

